"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _material = require("@mui/material");
var _TextField = _interopRequireDefault(require("@mui/material/TextField"));
var _styles = require("@mui/styles");
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _surveyUtils = require("../../utilities/surveyUtils");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var styles = function styles(theme) {
  return {
    radioButton: {
      display: 'flex',
      alignItems: 'center'
    },
    formControlLabel: {
      maxHeight: theme.spacing(4)
    }
  };
};
var CustomDiamServiceCheckbox = /*#__PURE__*/function (_Component) {
  function CustomDiamServiceCheckbox(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, CustomDiamServiceCheckbox);
    _this = _callSuper(this, CustomDiamServiceCheckbox, [props]);
    (0, _defineProperty2["default"])(_this, "handleChange", function (name) {
      return function (event) {};
    });
    (0, _defineProperty2["default"])(_this, "updateSelectedService", function (serviceID) {
      return function (event) {
        var selectedServices = [].concat(_this.state.selectedServices);
        if (event.target.checked) {
          selectedServices.push({
            serviceID: serviceID,
            percent: '',
            otherLabel: ''
          });
        } else {
          selectedServices = selectedServices.filter(function (r) {
            return Number(r.serviceID) !== Number(serviceID);
          });
        }
        _this.setState({
          selectedServices: selectedServices
        });
        _this.checkInput(selectedServices);
        _this.props.onChange(_this.convertToValue(selectedServices));
      };
    });
    ['updateSelectedService', 'updateServicePercent', 'convertToValue', 'checkInput', 'updateOtherLabel'].map(function (k) {
      return _this[k] = _this[k].bind(_this);
    });
    var value = _this.props.value;
    var _selectedServices = value ? value.map(function (v, index) {
      var a = JSON.parse(v);
      var serviceID = a.serviceID;
      var percent = a.percent === null ? '' : a.percent;
      var otherLabel = a.otherLabel === null ? '' : a.otherLabel;
      return {
        serviceID: serviceID,
        percent: percent,
        otherLabel: otherLabel
      };
    }) : [];
    _this.checkInput(_selectedServices);
    _this.state = {
      selectedServices: _selectedServices
    };
    return _this;
  }
  (0, _inherits2["default"])(CustomDiamServiceCheckbox, _Component);
  return (0, _createClass2["default"])(CustomDiamServiceCheckbox, [{
    key: "updateServicePercent",
    value: function updateServicePercent(serviceID) {
      var _this2 = this;
      return function (value) {
        var selectedServices = [].concat(_this2.state.selectedServices);
        var selectedService = selectedServices.find(function (s) {
          return Number(s.serviceID) === Number(serviceID);
        });
        if (selectedService) {
          selectedService.percent = value.target.value;
        }
        _this2.setState({
          selectedServices: selectedServices
        });
        _this2.checkInput(selectedServices);
        _this2.props.onChange(_this2.convertToValue(selectedServices));
      };
    }
  }, {
    key: "updateOtherLabel",
    value: function updateOtherLabel(serviceID) {
      var _this3 = this;
      return function (value) {
        var selectedServices = [].concat(_this3.state.selectedServices);
        var selectedService = selectedServices.find(function (s) {
          return Number(s.serviceID) === Number(serviceID);
        });
        if (selectedService) {
          selectedService.otherLabel = value.target.value;
        }
        _this3.setState({
          selectedServices: selectedServices
        });
        _this3.checkInput(selectedServices);
        _this3.props.onChange(_this3.convertToValue(selectedServices));
      };
    }
  }, {
    key: "convertToValue",
    value: function convertToValue(services) {
      var value = services.map(function (r) {
        return JSON.stringify({
          serviceID: r.serviceID ? r.serviceID : '',
          percent: r.percent,
          otherLabel: r.otherLabel
        });
      });
      return value;
    }
  }, {
    key: "checkInput",
    value: function checkInput(selectedServices) {
      var errorMessage = '';
      if (selectedServices.length < 3 || selectedServices.length > 5) {
        errorMessage = 'The number of imaging services selected MUST be between 3 and 5.  Please correct your selections, otherwise your assessment will be invalid.';
      } else {
        var sumPercent = 0;
        selectedServices.forEach(function (s) {
          sumPercent += Number(s.percent);
        });
        if (sumPercent < 80 || sumPercent > 100) {
          errorMessage = 'The sum of imaging studies percentage MUST be between 80 and 100%.  Please correct your entries, otherwise your assessment will be invalid.';
        }
      }
      this.props.showError(errorMessage);
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;
      var classes = this.props.classes;
      var selectedServices = this.state.selectedServices;
      var props = Object.assign({}, this.props);
      delete props.name;
      props.classes = Object.assign({}, this.props.classes);
      delete props.previousValue;
      delete props.classes.radioButton;
      delete props.classes.formControlLabel;
      delete props.showError;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: classes.radioButton
      }, /*#__PURE__*/_react["default"].createElement(_material.FormGroup, (0, _extends2["default"])({}, props, {
        style: {
          flexDirection: 'column'
        }
      }), this.props.answers.map(function (item) {
        var selectedService = selectedServices.find(function (s) {
          return s.serviceID == item.value;
        });
        var isOtherService = _surveyUtils.otherServices.indexOf(item.value) > -1;
        return /*#__PURE__*/_react["default"].createElement(_react.Fragment, {
          key: 'checkbox-container' + item.value
        }, /*#__PURE__*/_react["default"].createElement(_material.FormControlLabel, {
          className: classes.formControlLabel,
          key: 'checkbox-' + item.value,
          control: /*#__PURE__*/_react["default"].createElement(_material.Checkbox, {
            checked: !!selectedService,
            onChange: _this4.updateSelectedService(item.value)
          }),
          label: /*#__PURE__*/_react["default"].createElement("div", {
            style: {
              display: 'flex',
              alignItems: 'center'
            }
          }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], null, item.label))
        }), selectedService && isOtherService && /*#__PURE__*/_react["default"].createElement(_TextField["default"], {
          placeholder: "Other Service Name",
          key: 'other ' + item.value,
          defaultValue: selectedService.otherLabel || '',
          onBlur: _this4.updateOtherLabel(item.value)
        }), selectedService && /*#__PURE__*/_react["default"].createElement(_material.FormControlLabel, {
          className: classes.formControlLabel,
          key: 'percent-' + item.value,
          control: /*#__PURE__*/_react["default"].createElement(_TextField["default"], {
            key: 'percent' + item.value,
            type: "number",
            defaultValue: selectedService.percent || '',
            onBlur: _this4.updateServicePercent(item.value),
            inputProps: {
              min: 0,
              max: 100,
              step: 1,
              style: {
                textAlign: 'right'
              }
            }
          }),
          label: /*#__PURE__*/_react["default"].createElement("div", {
            style: {
              display: 'flex',
              alignItems: 'center'
            }
          }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], null, " % of imaging studies performed"))
        }));
      })));
    }
  }]);
}(_react.Component);
CustomDiamServiceCheckbox.propTypes = {
  previousValue: _propTypes["default"].array,
  answers: _propTypes["default"].array,
  onChange: _propTypes["default"].func.isRequired
};
var _default = exports["default"] = (0, _styles.withStyles)(styles)(CustomDiamServiceCheckbox);